import { loadCss } from "esri-loader";
import { Utils, TransformCoordinates } from "./Utils";
import DrawOverlaysBD from "./widgets/DrawOverlays/bd/DrawOverlaysBD";
import GeometrySearchBD from "./widgets/GeometrySearch/bd/GeometrySearchBD";
import { HeatMapBD } from "./widgets/HeatMap/bd/HeatMapBD";
import { JurisdictionPolice } from "./widgets/JurisdictionPolice/bd/JurisdictionPolice";
import { PointCollection } from "./widgets/Overlays/bd/PointCollection";
import WidgetsManagerBD from "./widgets/WidgetsManager/bd/WidgetsManagerBD";
import ToolTipBaiDu from "./widgets/Overlays/bd/ToolTipBaiDu";
import { ScaleControlBD } from "./widgets/MapControls/bd/ScaleCtrlBD";
import { NavigationControlBD } from "./widgets/MapControls/bd/NavigationCtrlBD";
import { OverlayBaidu } from "./widgets/Overlays/bd/OverlayBaidu";
import POISearchBD from "./widgets/POISearch/bd/POISearchBD";
import { MigrateChartCom } from "./widgets/MigrateChart/bd/MigrateChart_common";
import {
  ICenterLevel,
  ICustomTip,
  IDefinitionParameter,
  IDistrictParameter,
  IDrawOverlays,
  IFindParameter,
  IGeometrySearchParameter,
  IHeatImageParameter,
  IHeatParameter,
  ILayerConfig,
  IMapContainer,
  IOverlayClusterParameter,
  IOverlayDelete,
  IOverlayParameter,
  IPointGeometry,
  IPopUpTemplate,
  IResult,
  ISelectRouteHitTest,
  ISelectRouteParam,
  ISelectRouteResult,
  ISignalPhaseInfo,
  IStreetParameter,
  ISumoConnectInfo,
  ITrackParameter,
  IWidget,
  IRouteParameter,
  IMapControlParam,
  IPOILocalSearchParameter,
} from "@/types/map";

declare let BMap: any;

export default class MapAppBaidu implements IMapContainer {
  public view!: any;
  public baseLayers: Array<any> = [];
  public layerLoaded: any;
  public showGisDeviceInfo: any;
  public mouseOverMarker: any;
  public mapClick: any;
  public mapTouch: any;
  private showSubOD: boolean = false;

  public async initialize(mapConfig: any, mapContainer: string): Promise<void> {
    const apiUrl = mapConfig.arcgis_api || mapConfig.baidu_api || mapConfig.apiUrl || mapConfig.api_url; //"http://localhost:8090/baidu/BDAPI.js";
    let view: any;
    await Utils.loadScripts([`${apiUrl}`]);
    const apiRoot = apiUrl.substring(0, apiUrl.lastIndexOf("/"));
    const mapV = apiRoot + "/mapv.js";
    const heatMap = apiRoot + "/Heatmap_min.js";
    const drawManager = apiRoot + "/DrawingManager_min.js";
    const cluster1 = apiRoot + "/TextIconOverlay.js";
    const cluster2 = apiRoot + "/MarkerClusterer.js";
    const geometryUtil = apiRoot + "/GeoUtils.js";
    const rangingUtil = apiRoot + "/DistanceTool.js";
    const lushu = apiRoot + "/LuShu.js";

    await this.loadOtherScripts([heatMap, cluster1, cluster2, drawManager, geometryUtil, rangingUtil, lushu]).then((results: any) => {
      let failure_count = 0;
      let success_count = 0;
      results.forEach((result: any) => {
        if (result.status == "fulfilled") {
          ++success_count;
        } else {
          ++failure_count;
        }
      });
      console.log(success_count + " scripts loaded successful!");
      console.log(failure_count + " scripts loaded failed!");
    });

    ////已将css文件放在目录"./styles/"下
    // await this.loadOtherCSS([
    //   apiRoot + "/DrawingManager_min.css"
    // ]).then(() => { console.log("css loaded!") });

    let widgetStyle = mapConfig.widgetStyle ? mapConfig.widgetStyle : "assets/styles/style";
    let customcssFile: string = widgetStyle + "/dark.css";
    if (mapConfig.theme && mapConfig.theme.indexOf("light") > -1) {
      customcssFile = widgetStyle + "/light.css";
    }
    loadCss(customcssFile);
    view = new BMap.Map(mapContainer);
    let gisUrl = mapConfig.gisServer ? mapConfig.gisServer : this.getIpPort(apiUrl);

    if (mapConfig.theme === "dark") {
      view.setMapStyle({ style: "midnight" });
      //设置比例尺颜色
      this.loadOtherStyle(".BMap_scaleTxt {color: white !important;}").catch((err: any) => {
        console.log("change scaleBar color failed!");
      });
    }

    // 设置地图样式,目前支持normal（默认样式）,dark（深色样式）,light（浅色样式）三种
    if (mapConfig.options.mapStyle) {
      view.setMapStyle(mapConfig.options.mapStyle);
    }
    // //设置底图v2样式
    // if (mapConfig.options.mapStyleV2) {
    //   view.setMapStyleV2(mapConfig.options.mapStyleV2);
    // }

    if (mapConfig.baseLayers) {
      mapConfig.baseLayers.forEach((element: any) => {
        this.createLayer(view, element);
      });
    }
    let zoom = 12;
    let center = new BMap.Point(121.31, 31.2);
    if (mapConfig.options.zoom) {
      zoom = mapConfig.options.zoom;
    }
    if (mapConfig.options.center) {
      center = new BMap.Point(mapConfig.options.center[0], mapConfig.options.center[1]);
    }
    view.centerAndZoom(center, zoom);

    view.enableScrollWheelZoom();
    this.view = view;
    this.view.gisServer = gisUrl;

    view.addEventListener("click", (event: any) => {
      this.mapClick({
        x: event.point.lng,
        y: event.point.lat,
        lnt: event.point.lng,
        lat: event.point.lat,
      });
    });
    let xArr: any = []; //存放横坐标
    let yArr: any = []; //存放纵坐标
    view.addEventListener("touchstart", (event: any) => {
      //手指触摸屏幕的时候清空两个数组
      xArr.length = 0;
      yArr.length = 0;
    });
    view.addEventListener("touchmove", (event: any) => {
      //如果滑动了屏幕，xArr和yArr将各存入两个坐标值，即始未坐标值
      xArr.push(event.targetTouches[0].pageX);
      yArr.push(event.targetTouches[0].pageY);
    });
    view.addEventListener("touchend", (event: any) => {
      let far;
      let flag = true;
      //计算平移距离，区分滑动事件和点击事件
      if (xArr.length > 1 && yArr.length > 1) {
        far = (Math.abs(xArr[0] - xArr[xArr.length - 1]) ^ 2) + (Math.abs(yArr[0] - yArr[yArr.length - 1]) ^ 2);
        if (far > 30) {
          flag = false;
        }
      }
      if (flag) {
        this.mapTouch({
          x: event.point.lng,
          y: event.point.lat,
          lnt: event.point.lng,
          lat: event.point.lat,
        });
      }
    });
    if (mapConfig.widgets) {
      this.showWidgetTools(mapConfig.widgets);
    }

    this.setZoomCtrl(mapConfig.options?.zoomControl);
    this.setScaleBar(mapConfig.options?.scaleBar);
  }

  private async loadOtherScripts(scriptUrls: string[]): Promise<any> {
    let promises = new Array<Promise<any>>();
    scriptUrls.forEach(url => {
      promises.push(
        new Promise((resolve, reject) => {
          let scriptElement = document.createElement("script");
          scriptElement.src = url;
          scriptElement.onload = resolve;
          scriptElement.onerror = reject;
          document.body.appendChild(scriptElement);
        })
        // .catch((error)=>{
        //   // console.log(error);
        // })
      );
    });
    return Promise.allSettled(promises);

    // let promises = scriptUrls.map((url) => {
    //   return new Promise((resolve, reject) => {
    //     const scriptElement = document.createElement("script");
    //     scriptElement.src = url;
    //     scriptElement.onload = resolve;
    //     document.body.appendChild(scriptElement);
    //   });
    // });
    // return new Promise((resolve) => {
    //   Promise.all(promises).then((e) => {
    //     resolve(e);
    //   });
    // });
  }

  //加载css url
  private async loadOtherCSS(cssUrls: string[]): Promise<any> {
    let promises = cssUrls.map(url => {
      return new Promise((resolve, reject) => {
        const linkElement = document.createElement("link");
        linkElement.href = url;
        linkElement.rel = "stylesheet";
        linkElement.onload = resolve;
        linkElement.onerror = reject;
        document.body.appendChild(linkElement);
      });
    });
    return new Promise(resolve => {
      Promise.all(promises).then(e => {
        resolve(e);
      });
    });
  }

  //加载自定义style
  private async loadOtherStyle(styleString: string): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      const styleElement = document.createElement("style");
      styleElement.innerText = styleString;
      styleElement.onload = resolve;
      styleElement.onerror = reject;
      document.body.appendChild(styleElement);
    });
    return promise;
  }

  //得到url中的ip和port
  private getIpPort(url: string): string {
    let urls = url.split("/");
    let ip: string = "";
    for (let el in urls) {
      if (el.indexOf(":") > 0 || el.indexOf(".") > 0) {
        ip = el;
        break;
      }
    }
    if (ip === "") {
      ip = urls[2];
    }
    return ip;
  }

  //配置缩放控件
  private async setZoomCtrl(params: any) {
    if (!params || params.visible !== true) {
      return;
    }
    let mapCtrlParams = {
      type: "zoom",
      anchor: params.anchor,
      visible: params.visible,
      options: {
        xoffset: params.offset?.x,
        yoffset: params.offset?.y,
      },
    };
    this.setMapControl(mapCtrlParams);
  }

  //配置比例尺控件
  private async setScaleBar(params: any) {
    if (!params || params.visible !== true) {
      return;
    }
    let mapCtrlParams = {
      type: "scale",
      anchor: params.anchor,
      visible: params.visible,
      options: {
        unit: params.unit,
        xoffset: params.offset?.x,
        yoffset: params.offset?.y,
      },
    };
    this.setMapControl(mapCtrlParams);
  }

  public createLayer(view: any, layer: any) {
    switch (layer.type) {
      case "traffic":
        let trafficlayer = new BMap.TrafficLayer();
        if (layer.visible !== false) {
          view.addTileLayer(trafficlayer);
        }
        this.baseLayers.push({
          label: layer.label || "",
          type: layer.type || "",
          layer: trafficlayer,
          visible: layer.visible !== false,
        });
        break;
    }
  }

  public setMapStyle(param: string) {
    //this.view.setMapStyle(param);
  }
  public async addTileLayer(): Promise<IResult> {
    let data = this.baseLayers.find(baselayer => baselayer.label == "路况图层Label");
    if (data) {
      this.view.addTileLayer(data.layer);
      data.visible = true;
      return { status: 200, message: "路况图层已打开" };
    }
    let trafficlayer = new BMap.TrafficLayer();
    this.view.addTileLayer(trafficlayer);
    this.baseLayers.push({
      label: "路况图层Label" || "",
      type: "traffic" || "",
      layer: trafficlayer,
      visible: true,
    });
    return { status: 200, message: "路况图层已打开" };
  }

  public async deleteTileLayer(): Promise<IResult> {
    this.baseLayers.forEach(baselayer => {
      if (baselayer.label == "路况图层Label") {
        this.view.removeTileLayer(baselayer.layer);
        baselayer.visible = false;
      }
    });
    return { status: 200, message: "路况图层已关闭" };
  }

  public async addOverlays(params: IOverlayParameter): Promise<IResult> {
    if (!!params.allOverLayerStatus) {
      if (params.overlays.length < 800) {
        const overlay = OverlayBaidu.getInstance(this.view);
        overlay.showGisDeviceInfo = this.showGisDeviceInfo;
        overlay.mouseOverMarker = this.mouseOverMarker;
        return await overlay.addOverlays(params);
      } else {
        return await this.addPointCollection(params);
      }
    } else {
      const overlay = OverlayBaidu.getInstance(this.view);
      overlay.showGisDeviceInfo = this.showGisDeviceInfo;
      overlay.mouseOverMarker = this.mouseOverMarker;
      return await overlay.addOverlays(params);
    }
  }
  // 添加od线;
  public async showODData(params: any) {
    const chart = await MigrateChartCom.getInstance(this.view);
    this.showSubOD = true;
    let dom: any = document.getElementsByClassName("BMap_mask")[0];
    dom.style.zIndex = "201";
    // pointer-events: none;
    //事件穿透
    dom.style.pointerEvents = "none";
    chart.showODChartByData(params);
  }
  //隐藏od
  public hideMigrateChart(params?: { custom: boolean }) {
    const chart = MigrateChartCom.getInstance(this.view);
    this.showSubOD = false;
    let dom: any = document.getElementsByClassName("BMap_mask")[0];
    dom.style.zIndex = "9";
    chart.hideMigrateChart(params);
  }
  public async findFeature(params: IFindParameter): Promise<IResult> {
    const overlay = OverlayBaidu.getInstance(this.view);
    return await overlay.findFeature(params);
  }
  public async findLayerFeature(params: IFindParameter) {}
  public async addOverlaysCluster(params: IOverlayClusterParameter): Promise<IResult> {
    const overlay = OverlayBaidu.getInstance(this.view);
    overlay.showGisDeviceInfo = this.showGisDeviceInfo;
    overlay.mouseOverMarker = this.mouseOverMarker;
    return await overlay.addOverlaysCluster(params);
  }

  public async addHeatMap(params: IHeatParameter): Promise<IResult> {
    const heatmap = HeatMapBD.getInstance(this.view);
    return await heatmap.addHeatMap(params);
  }

  public async deleteOverlays(params: IOverlayDelete): Promise<IResult> {
    const overlay = OverlayBaidu.getInstance(this.view);
    return await overlay.deleteOverlays(params);
  }
  public async deleteOverlaysCluster(params: IOverlayDelete) {
    const overlay = OverlayBaidu.getInstance(this.view);
    await overlay.deleteOverlaysCluster(params);
  }
  public async deleteAllOverlays() {
    const overlay = OverlayBaidu.getInstance(this.view);
    overlay.showGisDeviceInfo = this.showGisDeviceInfo;
    await overlay.deleteAllOverlays();
  }
  public async deleteAllOverlaysCluster() {
    const overlay = OverlayBaidu.getInstance(this.view);
    overlay.showGisDeviceInfo = this.showGisDeviceInfo;
    await overlay.deleteAllOverlaysCluster();
  }
  public async addPointCollection(params: IOverlayParameter): Promise<IResult> {
    const ptc = PointCollection.getInstance(this.view);
    ptc.showGisDeviceInfo = this.showGisDeviceInfo;
    return await ptc.addOverlays(params);
  }
  public async deletePointCollection(params: IOverlayDelete): Promise<IResult> {
    const ptc = PointCollection.getInstance(this.view);
    return await ptc.deletePointCollection(params);
  }
  public async findPointCollection(params: IFindParameter) {
    const ptc = PointCollection.getInstance(this.view);
    return await ptc.findPointCollection(params);
  }
  public async hideOverlays(params: IOverlayDelete): Promise<IResult> {
    const overlays = OverlayBaidu.getInstance(this.view);
    return await overlays.hideOverlays(params);
  }
  public async showOverlays(params: IOverlayDelete): Promise<IResult> {
    const overlays = OverlayBaidu.getInstance(this.view);
    return await overlays.showOverlays(params);
  }
  public async deleteHeatMap(params: ILayerConfig) {
    const heatmap = HeatMapBD.getInstance(this.view);
    await heatmap.deleteHeatMap(params);
  }
  public async setMapCenter(params: IPointGeometry) {
    let x = params.x;
    let y = params.y;
    let center = new BMap.Point(x, y);
    this.view.panTo(center);
  }
  public async setMapCenterAndLevel(params: ICenterLevel) {
    let x = params.x;
    let y = params.y;
    let level = params.level || this.view.getZoom();
    let center = new BMap.Point(x, y);
    this.view.centerAndZoom(center, level);
  }

  public showLayer(params: ILayerConfig) {
    this.baseLayers.forEach(baselayer => {
      if ((params.label && baselayer.label === params.label) || (params.type && baselayer.type === params.type)) {
        if (!baselayer.visible) {
          this.view.addTileLayer(baselayer.layer);
          baselayer.visible = true;
        }
      }
    });
  }
  public hideLayer(params: ILayerConfig) {
    this.baseLayers.forEach(baselayer => {
      if ((params.label && baselayer.label === params.label) || (params.type && baselayer.type === params.type)) {
        if (baselayer.visible) {
          this.view.removeTileLayer(baselayer.layer);
          baselayer.visible = false;
        }
      }
    });
  }

  public async showJurisdiction() {
    const police = JurisdictionPolice.getInstance(this.view);
    await police.showJurisdiction();
  }
  public async hideJurisdiction() {
    const police = JurisdictionPolice.getInstance(this.view);
    await police.hideJurisdiction();
  }
  public async showDistrictMask(param: IDistrictParameter) {}
  public async hideDistrictMask() {}
  public async showRoad() {}
  public async hideRoad() {}
  public async showStreet() {}
  public async hideStreet() {}
  public async locateStreet(param: IStreetParameter) {}
  public async routeSearch(params: IRouteParameter): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public clearRouteSearch() {}
  public showRoutePoint(params: any) {}
  public clearRoutePoint() {}
  public async addDrawLayer(params: any): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public clearDrawLayer(params: ILayerConfig) {}

  public showMigrateChart(params: any) {}
  public showBarChart(params: any) {}
  public hideBarChart() {}
  public addHeatImage(params: IHeatImageParameter) {}
  public deleteHeatImage() {}

  public async startGeometrySearch(params: IGeometrySearchParameter): Promise<IResult> {
    let geometrySearch = GeometrySearchBD.getInstance(this.view);
    // geometrySearch.showGisDeviceInfo = this.showGisDeviceInfo;
    return await geometrySearch.startGeometrySearch(params);
  }
  public clearGeometrySearch() {
    let geometrySearch = GeometrySearchBD.getInstance(this.view);
    geometrySearch.clearGeometrySearch();
  }

  public async showDgene(params: any): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public hideDgene() {}
  public async addDgeneFusion(params: any): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public async restoreDegeneFsion(): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public showCustomTip(params: ICustomTip) {
    let className: string = params ? params.class || "custom-popup" : "custom-popup";
    if (params == undefined || (params && params.clear !== false)) {
      ToolTipBaiDu.clear(this.view, undefined, className);
    }
    if (params && params.geometry) {
      params.prop.className = className;
      params.prop.bubble = params.bubble !== false;
      let ctip = new ToolTipBaiDu(this.view, params.prop.vue, {}, params.geometry, params.prop);
    }
  }
  public showDgeneOutPoint(params: any) {}
  public changeDgeneOut() {}

  public async initializeRouteSelect(params: ISelectRouteParam) {}
  public async showSelectedRoute(params: ISelectRouteResult) {}
  public async playSelectedRoute(speed: number) {}
  public stopPlaySelectedRoute() {}
  public async routeHitArea(params: ISelectRouteHitTest): Promise<IResult> {
    return { status: -1, message: "" };
  }
  public async areaHitRoute(params: ISelectRouteHitTest): Promise<IResult> {
    return { status: -1, message: "" };
  }

  public async startDrawOverlays(params: IDrawOverlays): Promise<void> {
    const drawOverlayBD = DrawOverlaysBD.getInstance(this.view);
    return await drawOverlayBD.startDrawOverlays(params);
  }

  public async stopDrawOverlays(): Promise<void> {
    const drawOverlayBD = DrawOverlaysBD.getInstance(this.view);
    return await drawOverlayBD.stopDrawOverlays();
  }

  public async deleteDrawOverlays(params: IOverlayDelete): Promise<void> {
    const drawOverlayBD = DrawOverlaysBD.getInstance(this.view);
    return await drawOverlayBD.deleteDrawOverlays(params);
  }

  public async getDrawOverlays(): Promise<IResult> {
    const drawOverlayBD = DrawOverlaysBD.getInstance(this.view);
    return await drawOverlayBD.getDrawOverlays();
  }

  public async startLayerSearch(params: IGeometrySearchParameter): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public async startLayerDefinition(params: IDefinitionParameter): Promise<void> {}
  public async startTrackPlay(params: ITrackParameter): Promise<void> {}

  public async getOverlays(params: IOverlayDelete): Promise<IResult> {
    const overlay = OverlayBaidu.getInstance(this.view);
    return await overlay.getOverlays(params);
  }

  public async getRegionOverlays(params: IOverlayParameter): Promise<IResult> {
    return { status: 0, message: "" };
  }

  public async connectSumoSimulation(params: ISumoConnectInfo): Promise<IResult> {
    return { status: 0, message: "" };
  }

  public async setMapFocus(focusInfo: { type: string; id: string; scaleFactor?: number }): Promise<IResult> {
    return { status: -2, message: "no function" };
  }

  public async addAnimatePoints(params: IOverlayParameter): Promise<IResult> {
    return { status: -2, message: "no function" };
  }
  public async deleteAnimatePoints(params?: IOverlayDelete): Promise<IResult> {
    return { status: -2, message: "no function" };
  }

  public async startSignalPhase(params: ISignalPhaseInfo): Promise<IResult> {
    return { status: -2, message: "no function" };
  }
  public async showPopup(params: IPopUpTemplate) {}
  public showWidgetTools(params: Array<IWidget>) {
    let tool = WidgetsManagerBD.getInstance(this.view);
    tool.initWidgets(params);
  }
  public toggleWidget(params: string[]) {
    let tool = WidgetsManagerBD.getInstance(this.view);
    tool.toggleWidget(params);
  }

  public async closePopup() {
    const overlay = OverlayBaidu.getInstance(this.view);
    overlay.closePopup();

    const pc = PointCollection.getInstance(this.view);
    pc.closePopup();
  }

  public async setMapControl(params: IMapControlParam) {
    let instance: any;
    switch (params.type) {
      case "scale":
        //拿到实例
        instance = ScaleControlBD.getInstance(this.view);
        break;
      case "zoom":
        //拿到实例
        instance = NavigationControlBD.getInstance(this.view, params.options);
        break;
      default:
        return;
    }
    instance.set(params);
  }

  public async localSearch(params: IPOILocalSearchParameter): Promise<IResult> {
    let instance = POISearchBD.getInstance(this.view);
    return instance.localSearch(params);
  }
}
